import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { insertInlineFile, insertPlaceHolderFile, removePlaceHolderFile } from './FileUtils'
import { Button, Tooltip } from 'reactstrap'
import { FaFile } from 'react-icons/lib/fa'
import styles from './FileSlatePlugin.scss'

import FileGallerySlateButton from '../FileGallerySlateButton'
import Upload from '../Upload'

const TooltipContent = props => {
  if (props.uploadState === 'uploading') {
    return <div>Uploading ...</div>
  }

  const style = {
    padding: '5px 10px'
  }
  return <div>
    <div>File</div>
    <div style={style}><Button onClick={props.onUpload}>Upload</Button></div>
    <div style={style}><Button onClick={props.onGallery}>Gallery</Button></div>
  </div>
}

TooltipContent.propTypes = {
  uploadState: PropTypes.string,
  onUpload: PropTypes.func,
  onGallery: PropTypes.func
}

class FileButton extends Component {
  constructor (props) {
    super(props)

    this.uid = Date.now()

    this.state = {
      tooltipOpen: false,
      progress: 0,
      uploadState: 'default',
      urlModalIsOpen: false
    }
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    })
  }

  onClick = e => {
    this.onUpload()
  }

  onUpload = e => {
    this.input.click()
  }

  onGallery = e => {
    this.galleryButton.click()
  }

  onSelect = (e, file) => {
    const onChange = this.props.onChange
    const state = this.props.state
    const data = {
      href: file.location,
      title: file.name,
      fileId: file.id,
      isFile: true
    }
    onChange(insertInlineFile({ state, data }))
  }

  onStart = e => {
    const { state, onChange } = this.props
    this.setState({
      uploadState: 'uploading',
      progress: 0
    })
    this.props.setEditorReadOnly(true)
    onChange(insertPlaceHolderFile({ state }))
  }

  onFinish = file => {
    const { onChange } = this.props
    const data = {
      href: file.location,
      title: file.name,
      fileId: file.id,
      isFile: true
    }

    this.unlockEditor()

    // make sure you pass this.props.state as it will have changed!
    onChange(insertInlineFile({ state: this.props.state, data }))
  }

  unlockEditor = () => {
    const { onChange } = this.props
    onChange(removePlaceHolderFile({ state: this.props.state }))
    this.props.setEditorReadOnly(false)
    this.setState({ progress: 0, uploadState: 'default' })
  }

  onError = error => {
    console.info(error)
    this.unlockEditor()
  }

  getGalleryClick = onClick => {
    this.onGallery = onClick
  }

  render () {
    const { style, noTooltip } = this.props
    const { uploadState, tooltipOpen } = this.state
    const isOpen = tooltipOpen || uploadState === 'uploading'

    const customStyle = {
      position: 'relative'
    }

    const tooltip = (
        !noTooltip &&
        <Tooltip placement='top'
          isOpen={isOpen}
          target={'FileButton' + this.uid}
          toggle={this.toggle}
          autohide={false}
          >

          <TooltipContent
            uploadState={uploadState}
            onUpload={this.onUpload}
            onGallery={this.onGallery}
             />
        </Tooltip>
      )

    const acceptValue = [
      '.doc',
      '.docx',
      '.ppt',
      '.pptx',
      '.pdf',
      '.xls',
      '.xlsx',
      '.csv',
      '.txt',
      '.zip',
      '.html'
    ].join(', ')

    return (
      <Button id={'FileButton' + this.uid} style={{...style, ...customStyle}}
        onClick={this.onClick} color={'secondary'}
        className={styles.FileButton}>

        <FaFile />

        {tooltip}

        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          height: '100%',
          width: `${this.state.progress}%`,
          opacity: 0.4,
          backgroundColor: !this.state.error ? '#000' : '#92063E'
        }} />

        <Upload
          getRef={input => { this.input = input }}
          accept={acceptValue}
          onFinish={this.onFinish}
          onStart={this.onStart}
          onError={this.onError}
          hide
          />

        <FileGallerySlateButton
          match={this.props.match}
          history={this.props.history}
          state={this.props.state}
          onChange={this.props.onChange}
          getClick={this.getGalleryClick}
          filters={{type: 'not-image'}}
          onSelect={this.onSelect}
          hide
          />
      </Button>
    )
  }
}

FileButton.propTypes = {
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  setEditorReadOnly: PropTypes.func.isRequired,
  noTooltip: PropTypes.bool,
  style: PropTypes.object
}

export default FileButton



// WEBPACK FOOTER //
// ./src/components/FileSlatePlugin/FileButton.js